import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';

const required = value => value ? undefined : 'Required';

const CaptainManageEventChangeModal = ({
  availableEvents,
  currentEventName,
  visible,
  handleSubmit,
  onCancel,
  onSubmit
}) =>(
  <StandardModal
    title={`Change Event - ${currentEventName}`}
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <form
          onSubmit={handleSubmit(onSubmit)}>
          <Field
            name="parentSquadId"
            component={StandardSelectField}
            options={availableEvents}
            label={`Available Events`}
            placeholder={availableEvents.length ? 'Select an option' : 'No available times'}
            simpleValue
            searchable
            validate={[ required ]}
          />
          <div className="form-group text-right">
              <button
                type="button"
                className="btn btn-link"
                onClick={() => onCancel()}
              >Cancel</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              ><i className="fa fa-floppy-o" /> {'Save'}</button>
          </div>
          <input type="hidden" 
            name="entryId"/>
        </form>
      </div>
    </StandardModal>
);

CaptainManageEventChangeModal.propTypes = {
  availableEvents: PropTypes.arrayOf(PropTypes.object),
  currentEventName: PropTypes.string,
  entryId: PropTypes.string,
  visible: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
};

CaptainManageEventChangeModal.defaultProps = {
  availableEvents: [],
  currentEventName: '',
  entryId: '',
  visible: false
};

export default reduxForm({
  form: 'captainManageEventChangeForm'
})(CaptainManageEventChangeModal);



// WEBPACK FOOTER //
// ./src/features/registration/manage/EventChangeModal.jsx